// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/styles.js
//  wBtn · wBtnSm · wGhostSm · wPur · wAcc · wInp · wPanel · wLbl
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

export const wBtn = (bg, bd, col) => ({ background: bg, border: `1px solid ${bd}`, color: col, borderRadius: 8, padding: "8px 16px", cursor: "pointer", fontSize: 13, fontWeight: 700, fontFamily: "inherit" });

export const wBtnSm = (bg, bd, col) => ({ ...wBtn(bg, bd, col), padding: "5px 11px", fontSize: 12 });

export const wGhostSm = wBtnSm("transparent", THEME.border, THEME.textMuted);

export const wPur = wBtn(THEME.purpleDim, THEME.purple, THEME.purple);

export const wAcc = wBtn(THEME.accentDim, THEME.accent, THEME.accent);

export const wInp = { background: THEME.surface, border: `1px solid ${THEME.border}`, color: THEME.text, borderRadius: 8, padding: "9px 12px", fontSize: 13, width: "100%", boxSizing: "border-box", outline: "none", fontFamily: "inherit" };

export const wPanel = { background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 14, padding: 18 };

export const wLbl = { color: THEME.textMuted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 };
